// extracted by mini-css-extract-plugin
export default {"DialogFooterButtons":"CheckTagNameDialog-module__DialogFooterButtons--HNAWb"};